import { client } from "@lib/api";
import useSWR from "swr";

type InstructionContent = {
    title: string;
    unordered: boolean;
    content: string[];
};
  
type BankTransferInstructions = {
    [bank: string]: InstructionContent[];
};

const useSupportedVirtualAccountInstructions = () => {
    const { data, isLoading, error } = useSWR('/v2/wallet/top-up-bank-instruction', client.doGet)
    return {
        data: data as BankTransferInstructions | undefined,
        isLoading,
        error
    }
}

export default useSupportedVirtualAccountInstructions